import { render, staticRenderFns } from "./PlatformIconViewer.vue?vue&type=template&id=5239e5ae"
import script from "./PlatformIconViewer.vue?vue&type=script&lang=js"
export * from "./PlatformIconViewer.vue?vue&type=script&lang=js"
import style0 from "./PlatformIconViewer.vue?vue&type=style&index=0&id=5239e5ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports